// removed by extract-text-webpack-plugin
module.exports = {"nf-add-tool":"nf-add-tool","nf-add-tool__form":"nf-add-tool__form"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AddInventory/AddInventory.scss
// module id = 5321
// module chunks = 1